import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Navigate } from 'react-router-dom';
import { CenterFrameLayout } from 'Layouts';
import { SecondaryText } from 'Components/Texts';
import { withSubscriptions } from 'Components/WithSubscriptions';
import { withAuth } from 'Components/WithAuth';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { GIFTING_QUERY_PARAM, DEEPLINK, SHEER_FIRST_RESPONDER_TYPE } from 'Utils/Constants';
import { withPlans } from 'Components/WithPlans';
import { withServicesStatus } from 'Utils/ServicesStatus';
import { checkIfShowSheerBanner, isDefaultPlanFlow } from 'Utils/Analytics/Amplitude';
import CreateEmailContainer from 'Features/CreateAccount/CreateEmailContainer';
import { SheerIdBanner } from 'Features/SheerIdPromoBanner/SheerIdBanner';
import { getSheerVerificationId, getProductSKUSheerType, getSheerIdType } from 'Utils/SheerIdHelpers';
import './CreateContainer.css';
import { getFeatureFlag } from 'Utils/FeatureFlags';

export class CreateContainerComponent extends Component {
  componentDidMount() {
    trackEvent(TRACKING_ENUMS.EVENT_SIGNUP_STARTED);
  }

  render() {
    const {
      user,
      routes,
      isGifting,
      pageStartSource,
      bango,
      isPlanSelected,
      onSignInSuccess,
      onSignUpSuccess,
      defaultConfig,
    } = this.props;

    const urlParams = new URLSearchParams(location.search);
    const bangoProductId = bango.productId;
    const sheerType = urlParams.get('sheerVerification') || getProductSKUSheerType(bangoProductId);
    const alreadyHasVerificationID = urlParams.get('verificationID');
    const isBango = bango.subscriptionId;

    const searchParam = isGifting ? `${GIFTING_QUERY_PARAM}` : `return_to=${location.pathname}${location.search}`; //create account screen including params

    const title = isGifting ? 'Create Your Account To Redeem' : 'Create Your Account';

    const { enableSheerIdBanner } = defaultConfig;
    const showBanner =
      (isDefaultPlanFlow() && !isBango && !isGifting && enableSheerIdBanner && !getSheerVerificationId()) ||
      checkIfShowSheerBanner();
    const sheerIdType = getSheerIdType();

    if (user.isAuthenticated) {
      if (isPlanSelected) {
        if (bango.subscriptionId) {
          return <Navigate replace to={routes.bangoFinal} />;
        } else {
          return <Navigate replace to={routes.payment} state={{ from: alreadyHasVerificationID && DEEPLINK }} />;
        }
      } else if (!bango.subscriptionId && !sheerType) {
        // if user signed in but with an invalid url or invalid pre-selected plan sku
        return <Navigate replace to={routes.signupPlans} />;
      } else if (sheerType) {
        return <Navigate replace to={`${routes.sheerIdVerification}?sheerVerification=${sheerType}`} />;
      }
    } else if (alreadyHasVerificationID) {
      return <Navigate replace to={sheerIdType === SHEER_FIRST_RESPONDER_TYPE ? routes.signup : routes.signin} />;
    }

    return (
      <CenterFrameLayout
        title={title}
        showLoader={user.isFetching}
        modernLayout
        customFrameClass={showBanner && 'frameWithSheerIdBanner'}
      >
        {showBanner && <SheerIdBanner />}
        <CreateEmailContainer
          onSignInSuccess={onSignInSuccess}
          onSignUpSuccess={onSignUpSuccess}
          submitButtonText="Continue"
          pageStartSource={pageStartSource}
        />
        <SecondaryText
          key="b"
          alignText="centerText"
          text={[
            'Already have an account? ',
            <Link
              key="0"
              to={{
                pathname: routes.signin,
                search: searchParam,
              }}
              className="blueLink"
            >
              Sign in
            </Link>,
          ]}
        />
      </CenterFrameLayout>
    );
  }
}

const mapStateToProps = ({
  user,
  appConfig: { routes, defaultConfig },
  purchaseMode: { isGifting = false },
  tracking: { pageStartSource },
  integrations: { bango },
  plans: { isPlanSelected },
}) => ({
  user,
  routes,
  isGifting,
  pageStartSource,
  bango,
  isPlanSelected,
  defaultConfig,
});

const ConnectedCreateContainer = connect(mapStateToProps)(CreateContainerComponent);

const CreateContainerWithServicesStatus = withServicesStatus(ConnectedCreateContainer);
const CreateContainerWithPlans = withPlans(CreateContainerWithServicesStatus);
const CreateContainerWithSubscriptions = withSubscriptions(CreateContainerWithPlans);
export const CreateContainer = withAuth(CreateContainerWithSubscriptions);
